import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { CustomerService } from "src/app/services/customer.service";
import { ProductService } from "src/app/services/products.service";
import { VendorService } from "src/app/services/vendor.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NetworkService } from "src/app/services/network.service";
import { GeoService } from "src/app/services/geo.service";
import { SalesInvoiceService } from "src/app/services/misc/sales/sales.service";
import Swal from "sweetalert2";
import { CompanyService } from "src/app/services/company.service";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, lastValueFrom, map } from "rxjs";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
    selector: 'app-add-invoice',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})
export class SalesInvoiceAddComponent implements OnInit, AfterViewInit {
    @ViewChild('fromDateRef') fromDateRef: ElementRef;
    invoiceForm: FormGroup;
    isFormSubmitted = false;
    customerList: any[];
    productList: any[];
    vendorList: any[];
    filteredProductList: any[];
    financialyearList = [{ id: 1, name: '2024-01-19' }];
    defaultType: any;
    activeId: any;
    context: any;
    //AWBListDB : any[] = [];
    allAWBList: any[] = [];
    singleAWBList: any[] = [];
    //customer: any[] = [];
    filteredCustomer = [];
    allCustomerCounts: any = [];
    AllCustomerCount: any = [];
    ServiceCenterOptions: [];
    productTypeList = [{ name: 'Domestic' }, { name: 'International' }, { name: 'Import' }];
    serviceList: any[] = [];
    originCityList: any[] = [];
    destinationCityList: any[] = [];
    countryCode: any;
    countryList: any[] = [];
    destinationStateList: any[] = [];
    originStateList: any[] = [];
    dropDownSettings = {};
    enabledAWB = false;
    addressBookList: any[] = [];
    paymentOptions: any[] = [{ name: 'Credit' }, { name: 'Cash' }, { name: 'COD' }];
    userData: any;
    companyList: any[];
    serviceCenterCountry: string;
    serviceCenterState: string;
    statusList: any = [{ id: 1, name: 'Delivered' }, { id: 2, name: 'Returned' }, { id: 3, name: 'Not Delivered' }, { id: 4, name: 'Hold' }, { id: 5, name: 'Delayed' }];
    registerTypeList= [];
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
      };
    private customerGridApi!: GridApi;
    private AWBGridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        // domLayout: "autoHeight",
        cellStyle: { textAlign: 'end' },

    };
    rowDataCustWise: any[] = []
    rowDataAWBWise: any[] = []
    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        suppressRowClickSelection: true,
        paginationPageSize: 10,
        domLayout: "autoHeight",
    }
    columnDefsCustWise =
        [
            {
                headerName: 'Name',
                field: 'name',
                cellStyle: { textAlign: 'start' },
                minWidth: 250,
                pinned: 'left',
                checkboxSelection: true, headerCheckboxSelection: true,
            },
            { headerName: 'AWB Count', field: 'totalCount', cellStyle: { textAlign: 'center' } },
            { headerName: 'Total Amount', field: 'totalAmount' },
            { headerName: 'IGST', field: 'igst' },
            { headerName: 'CGST', field: 'csgt' },
            { headerName: 'SGST', field: 'sgst' },
            {
                headerName: 'Grand Total',
                field: 'grandTotal',
                minWidth: 120,
                pinned: 'right'
            },
        ]

    columnDefsAWBWise = [
        {
            headerName: 'AWB No.', checkboxSelection: true, headerCheckboxSelection: true,
            field: 'awbnumber',
            minWidth: 140,
            pinned: 'left'
        },
        { headerName: 'Date', field: 'Date', minWidth: 100, },
        {
            headerName: 'Consignee',
            field: 'ConsigneeName',
            minWidth: 250,
            cellStyle: { textAlign: 'start' }
        },
        { headerName: 'Pieces', field: 'pieces', minWidth: 90, cellStyle: { textAlign: 'center' } },
        { headerName: 'Weight', field: 'weight', minWidth: 90 },
        // { headerName: 'Total Amount', field: 'totalamount', minWidth: 120 },
        { headerName: 'Contract Amount', field: 'freightamount', minWidth: 110 },
        { headerName: 'Other Charges', field: 'otherchargesamount', minWidth: 110 },
        { headerName: 'Total Fuel', field: 'fuelamount', minWidth: 90 },
        { headerName: 'IGST', field: 'igst', minWidth: 90 },
        { headerName: 'CGST', field: 'csgt', minWidth: 90 },
        { headerName: 'SGST', field: 'sgst', minWidth: 90 },
        {
            headerName: 'Grand Total',
            field: 'totalamount',
            minWidth: 120,
            pinned: 'right'
        },
    ];

    selectedSCId = null;
    selectedCustomerList: any[] = [];

    awbConfig = {
        isGenerateInVall: false
    }
    selectedAWBList: any[];
    useEnterKey: any;
    billingTypeList = ['Daily', 'Weekly', 'Fortnightly', 'Monthly'];
    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private customerService: CustomerService,
        private vendorService: VendorService,
        private productService: ProductService,
        private serviceCenter: NetworkService,
        private ngxLoaderService: NgxUiLoaderService,
        private salesInvoiceService: SalesInvoiceService,
        private geoService: GeoService,
        private router: Router,
        private companyService: CompanyService,
        private addressbookService: AddressBookService,
        private awbService: AWBService,
        private configService: ConfigService,
        private titleService: Title,
        public utilities: Utilities,
    ) {
        titleService.setTitle('Sales');
        this.context = { componentParent: this };
    }
    currentDate = this.formateDate(new Date()).dateString;

    async ngOnInit() {
        this.checkPermission();
        this.registerTypeList = ['B2B', 'B2C', 'SEZWP'];

        this.invoiceForm = this.formBuilder.group({
            ddlCompany: [null, Validators.required],
            ddlVendor: [null],
            //selectionSwitch: ['single'],
            txtEnabledAWB: new FormControl({ disabled: true, value: false }),
            txtFromDate: [this.currentDate, Validators.required],
            txtToDate: [this.currentDate, Validators.required],
            txtInvoiceDate: [this.currentDate],
            txtInvoiceNo: [null, Validators.pattern(/^[0-9]{0,15}$/)],
            ddlProduct: [null],
            ddlVendorService: [null],
            txtShipper: [null],
            ddlProductType: [null],
            ddlBillingType: [null],
            ddlCustomer: [null],
            ddlOriginCountry: [null],
            ddlOriginState: [null],
            ddlOriginCity: [null],
            ddlDestinationCountry: [null],
            ddlDestinationState: [null],
            ddlDestinationCity: [null],
            txtAwbNo: [null],
            txtPodCollectedEntry: [false],
            ddlPaymentType: [this.paymentOptions[0].name],
            ddlStatus: [null],
            ddlRegisterType: [null],
        });

        this.dropDownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "name",
            selectAllText: "Select All",
            unSelectAllText: "Unselect All",
            itemsShowLimit: 3,
            allowSearchFilter: true,
        }

        this.getAllCustomers();
        this.getAllServiceCenter();
        this.bindCountries();
        this.bindProduct();
        this.bindVendor();
        await this.getAllCompanies();
        this.bindAddressBook();
        // this.getAllPaymntModes();
        this.getConfigs();
        this.appCoreService.SelectedServiceCenter().subscribe((val) => {
            this.selectedSCId = val;
        });
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceForm) : null;
    }

    checkPermission(): any {
        this.userData = this.appCoreService.GetUserData();
        this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;
        const permission = this.userData.config.filter(x => x.categoryname === 'Sales');
        if (permission.length) {
          this.permConfig.isViewAllowed = permission[0].view;
          this.permConfig.isAddAllowed = permission[0].add;
          this.permConfig.isEditAllowed = permission[0].edit;
          this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    loadDefaultValues() {
        const selectedFromDate = this.invoiceForm.get('txtFromDate').value;
        const selectedToDate = this.invoiceForm.get('txtToDate').value;
        //this.invoiceForm.reset();
        this.invoiceForm.get('txtFromDate').setValue(selectedFromDate);
        this.invoiceForm.get('txtToDate').setValue(selectedToDate);
        //this.invoiceForm.get('selectionSwitch').setValue('single');
        this.invoiceForm.get('txtEnabledAWB').setValue(false);
        this.invoiceForm.get('txtInvoiceDate').setValue(this.currentDate);
    }
    // onChangeProductType() {
    //     this.invoiceForm.controls.ddlProduct.reset();
    //     const productType = this.invoiceForm.controls.ddlProductType.value;
    //     this.filteredProductList = productType ? this.productList.filter(product => product.shipmenttype === productType) : this.productList;
    // }

    searchFiltered() {
        // if (changeFieldType === 'fromDate' || changeFieldType === 'toDate') {
        //     this.loadDefaultValues()
        // }
        // this.selectedAWBList = [];
        // this.invoiceForm.get('txtEnabledAWB').disable();
            
        this.rowDataCustWise = [];
        this.rowDataAWBWise = [];
        this.allAWBList = [];
        let shipper = this.invoiceForm.controls.txtShipper?.value || "";
        let shipperid = null;
        if (typeof (shipper) === 'object') {
            shipperid = shipper?.id || null;
        }

        /* not in use */
        // const isBilltoServiceCenter = this.companyList.filter(x => x.id == this.invoiceForm.get('ddlCompany').value)[0]?.billto == 'Service Center';

        const req = {
            searchtype: 'invoice',
            fromdate: this.invoiceForm.get('txtFromDate')?.value,
            todate: this.invoiceForm.get('txtToDate')?.value,
            productid: this.invoiceForm.get('ddlProduct')?.value,
            producttype: this.invoiceForm.get('ddlProductType')?.value,
            billingtype: this.invoiceForm.get('ddlBillingType')?.value,
            vendorid: this.invoiceForm.get('ddlVendor')?.value,
            serviceid: this.invoiceForm.get('ddlVendorService')?.value,
            companyid: this.invoiceForm.get('ddlCompany')?.value,
            servicecenterid: this.selectedSCId,
            customerid: this.invoiceForm.get('ddlCustomer')?.value,
            shipperid: shipperid,
            origincountry: this.invoiceForm.get('ddlOriginCountry')?.value,
            originstate: this.invoiceForm.get('ddlOriginState')?.value,
            origincity: this.invoiceForm.get('ddlOriginCity')?.value,
            destinationcountry: this.invoiceForm.get('ddlDestinationCountry')?.value,
            destinationstate: this.invoiceForm.get('ddlDestinationState')?.value,
            destinationcity: this.invoiceForm.get('ddlDestinationCity')?.value,
            ispodreceived: this.invoiceForm.get('txtPodCollectedEntry')?.value,
            paymenttype: this.invoiceForm.get('ddlPaymentType')?.value,
            status: (this.invoiceForm.get('ddlStatus')?.value?.length) ? this.invoiceForm.get('ddlStatus')?.value : null,
            registertype : this.invoiceForm.get('ddlRegisterType')?.value,
        };

        try {
            this.ngxLoaderService.start();
            this.awbService.Search(req).subscribe((res) => {
                if (res && res.success) {
                    console.log("res :", res.data);
                    this.ngxLoaderService.stop();
                    if (!res.data.length) {
                        return this.appCoreService.showMessage('No bookings found', '', 'error');
                    }
                    this.allAWBList = [...res.data];
                    let filteredCust: any[] = [];

                    this.allAWBList.filter((a, i) => this.allAWBList.findIndex((s) => a.customerid === s.customerid) === i).map((x) => {
                        filteredCust.push({
                            ...x,
                            id: x.customerid,
                            name: x.customername
                        });
                    });
                    //console.log("filteredCust", filteredCust);
                    this.filteredCustomer = [...filteredCust];
                    // console.log('this.filteredCustomer', this.filteredCustomer);
                    this.onCustomerSelect(this.filteredCustomer)
                    //console.log('filteredCustomer', this.filteredCustomer);
                }
            });

        } catch (e) {
            console.log(e);
            this.ngxLoaderService.stop();
        }
    }

    getAllCustomers() {
        try {
            this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
                if (res) {
                    this.customerList = res.data;
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    onCustomerSelect(selectedCustomers, type?: string) {
        this.rowDataCustWise = [];
        this.enabledAWB = selectedCustomers?.length === 1 ? true : false;

        // this.invoiceForm.get('txtEnabledAWB').enable();
        // this.invoiceForm.get('txtEnabledAWB').setValue(false);

        // !this.enabledAWB ? this.invoiceForm.get('txtEnabledAWB').disable() : this.invoiceForm.get('txtEnabledAWB').enable();

        if (selectedCustomers?.length) {
            selectedCustomers.forEach(element => {
                if (this.allAWBList?.length && element.id != "") {
                    let filteredCustWiseList = this.allAWBList.filter(x => x.customerid == element.id);
                    let shipmentAmount = 0, igstamount = 0, sgstamount = 0, cgstamount = 0;
                    let grandTotal = 0;
                    if (filteredCustWiseList?.length) {
                        filteredCustWiseList.forEach((val) => {
                            // console.log('val', val);
                            shipmentAmount += parseFloat(val.shipmentvalue || 0);
                            igstamount += parseFloat(val.tax?.igst || 0);
                            sgstamount += parseFloat(val.tax?.sgst || 0);
                            cgstamount += parseFloat(val.tax?.cgst || 0);
                        });

                        // Calculate grandTotal based on the sum of shipmentAmount, igstamount, sgstamount, and cgstamount
                        grandTotal = shipmentAmount + igstamount + sgstamount + cgstamount;

                        let obj = {
                            id: element.id,
                            code: 1,
                            name: element.name,
                            totalCount: filteredCustWiseList?.length,
                            totalAmount: Number(shipmentAmount)?.toFixed(3) || 0,
                            igst: igstamount?.toFixed(3) || 0,
                            csgt: cgstamount?.toFixed(3) || 0,
                            sgst: sgstamount?.toFixed(3) || 0,
                            grandTotal: grandTotal?.toFixed(3),
                        };

                        this.rowDataCustWise = [...this.rowDataCustWise, obj];
                    }

                }
            });
        }
    }

    getSingleCustomer() {
        this.invoiceForm.get('txtEnabledAWB').setValue(false);
        let customerId = this.invoiceForm.get('ddlCustomer').value;
        let shipmentAmount: number = 0;
        this.rowDataCustWise = [];

        if (this.allAWBList?.length && customerId != "") {
            let filteredCustWiseList = this.allAWBList.filter(x => x.customerid == customerId);
            this.singleAWBList = filteredCustWiseList;

            // attach event listener to check selected rows

            if (filteredCustWiseList?.length) {
                filteredCustWiseList.forEach((keys: any) => {
                    shipmentAmount = parseInt(keys.shipmentvalue) + shipmentAmount;
                });

                let customerName = this.customerList.find(x => x.id == customerId)?.name;
                let obj = {
                    code: 1,
                    name: customerName,
                    totalCount: filteredCustWiseList.length,
                    totalAmount: shipmentAmount,
                    igst: 0,
                    csgt: 0,
                    sgst: 0,
                    grandTotal: shipmentAmount,
                }
                this.rowDataCustWise = [...this.rowDataCustWise, obj];
            }
        }
    }

    onCustomerSelected() {
        this.selectedCustomerList = this.customerGridApi.getSelectedRows();

        if (this.customerGridApi.getSelectedRows().length == 1) {
            //enable awbwise switch
            this.enabledAWB = true;
            this.invoiceForm.get('txtEnabledAWB').enable();
        } else {
            //disable awbwise switch
            this.selectedAWBList = [];
            this.invoiceForm.get('txtEnabledAWB').disable();
        }
    }

    onAWBSelected() {
        this.selectedAWBList = this.AWBGridApi.getSelectedRows();
    }

    showDataAWBWise() {
        
        const awbWise = this.invoiceForm.get('txtEnabledAWB').value;
        if (awbWise) {
            //if not a single customer is selected the warning : Please select a customer
            let customerAWBList = [];
            this.rowDataAWBWise = [];

            let customers: any[] = this.rowDataCustWise;
            //on select single customer 

            if (customers?.length) {
                customerAWBList = this.allAWBList.filter(x => x.customerid == this.selectedCustomerList[0].id);
                customerAWBList.forEach((keys: any) => {
                    let row = {
                        customerid: customers[0].id,
                        awbnumber: keys.awbnumber,
                        Date: keys.bookingdate,
                        ConsigneeName: keys?.consigneename,
                        pieces: keys.pieces,
                        weight: keys.actualweight,
                        totalamount: Number(keys.totalamount).toFixed(3),
                        freightamount: parseFloat(keys.freightamount || 0).toFixed(3),
                        otherchargesamount: parseFloat(keys.otherchargesamount || 0).toFixed(3),
                        fuelamount: parseFloat(keys.fuelamount || 0).toFixed(3),
                        igst: parseFloat(keys.tax?.igst || 0).toFixed(3),
                        csgt: parseFloat(keys.tax?.cgst || 0).toFixed(3),
                        sgst: parseFloat(keys.tax?.sgst || 0).toFixed(3),

                        // Calculate grandTotal as the sum of relevant amounts
                        grandTotal: (
                            parseFloat(keys.freightamount || 0) +
                            parseFloat(keys.otherchargesamount || 0) +
                            parseFloat(keys.fuelamount || 0) +
                            parseFloat(keys.tax?.igst || 0) +
                            parseFloat(keys.tax?.cgst || 0) +
                            parseFloat(keys.tax?.sgst || 0)
                        ).toFixed(3)
                    };

                    this.rowDataAWBWise.push(row);
                });
            }

        } else {
            if (!this.allAWBList.length) {
                this.enabledAWB = false;
                this.invoiceForm.get('txtEnabledAWB').disable();
            }
        }
    }

    generateInvoice() {
        if (this.invoiceForm.valid) {
            let customerAWBList: any[] = [];

            if (this.enabledAWB && this.invoiceForm.get('txtEnabledAWB').value && !this.selectedAWBList?.length) {
                this.openWarningDialog("Kindly select the AWBs listed.");
                return;
            }
            this.selectedCustomerList.forEach(item => {
                let isawbSelected = this.enabledAWB && this.invoiceForm.get('txtEnabledAWB').value ? this.selectedAWBList.map(x => x.customerid).includes(item.id) : false;

                customerAWBList.push({
                    customerid: item.id,
                    awbs: isawbSelected
                        ? this.selectedAWBList.map((x) => ({ "awbnumber": x.awbnumber, "freightamount": x.freightamount, "otherchargesamount": x.otherchargesamount, "fuelamount": x.fuelamount }))
                        : this.allAWBList?.filter(x => x.customerid === item.id).map((x) => (
                            { "awbnumber": x.awbnumber, "freightamount": x.freightamount, "otherchargesamount": x.otherchargesamount, "fuelamount": x.fuelamount }))
                });
            });

            if (!customerAWBList?.length) {
                this.openWarningDialog("You must select atleast 1 customer to generate the invoice.");
                return;
            }

            let requestObject = {
                invoiceno: this.invoiceForm.controls.txtInvoiceNo.value,
                invoicedate: this.invoiceForm.controls.txtInvoiceDate.value,
                invoicestartdate: this.invoiceForm.controls.txtFromDate.value,
                invoiceenddate: this.invoiceForm.controls.txtToDate.value,
                companyid: this.invoiceForm.controls.ddlCompany.value,
                //servicecenterid: this.invoiceForm.controls.ddlServiceCenter.value,
                producttype: this.invoiceForm.controls.ddlProductType.value,
                billingtype: this.invoiceForm.controls.ddlBillingType.value,
                paymenttype: this.invoiceForm.controls.ddlPaymentType.value,
                generatebyservicecenterid: this.selectedSCId,
                customerAWBs: customerAWBList,
                additionalinfo:{
                    productid: this.invoiceForm.controls.ddlProduct.value,
                }
            }
            // console.log("req object : ", requestObject);
            this.ngxLoaderService.start();
            try {
                this.salesInvoiceService.AddSalesInvoice(requestObject).subscribe((res) => {
                    if (res && !res.success) {
                        this.ngxLoaderService.stop();
                        //this.appCoreService.showMessage(res?.message, '', 'error');
                        this.openWarningDialog(res?.message);
                    } else if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.openConfirmationDialog(`Invoice generated successfully.`);
                        //this.appCoreService.showMessage('Record Saved Successfully.', 'Success', 'success');
                    }
                })
            } catch (e) {
                this.ngxLoaderService.stop();
                console.log(e);
            }
        }
    }


    // ----------------------*------------------------
    bindProduct() {
        this.productService.GetAll({ isactive: true }).subscribe((res) => {
            this.productList = res?.success ? res.data : [];
        })
    }

    async getAllCompanies() {
        try {
            const res = await lastValueFrom(this.companyService.GetAll({ isactive: true }));
            if (res && res.success) {
                this.companyList = res.data;
                //select default
                this.invoiceForm.get('ddlCompany').setValue(this.companyList.find(x => x.isdefault)?.id);
                //if billto company then show service center
                //this.showServiceCenter = defaultcompany[0].billto == 'Service Center' ? true : false;
                //this.AllCustomerCount();
            }
        } catch (e) {
            console.error(e);
        }
    }

    onCompanySelect() {
        this.searchFiltered();
    }

    onChangeServiceCenter() {
        const serviceCenter: any = this.ServiceCenterOptions.filter((x: any) => x.id === this.invoiceForm.get('ddlServiceCenter').value);
        this.serviceCenterCountry = serviceCenter[0].location.country;
        this.serviceCenterState = serviceCenter[0].location.state;
    }

    onGridReadyCustomerWise(params: GridReadyEvent) {
        this.customerGridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    onGridReadyAWBWise(params: GridReadyEvent) {
        this.AWBGridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
        this.showDataAWBWise();
    }
    // getAllCustomers() {
    //     try {
    //         this.customerService.GetAll({scid: this.appCoreService.GetUserData().selectedServiceCenter}).subscribe((res) => {
    //             if (res && res.success) {
    //                 this.customerList = res.data;
    //                 console.log('customerList', this.customerList);

    //             }
    //         })
    //     } catch (e) {
    //         console.error(e);
    //     }

    // }
    getAllServiceCenter() {
        try {
            this.serviceCenter.GetAllServiceCenters({ isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.ServiceCenterOptions = res.data;
                } else {
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindVendor() {
        this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
            this.vendorList = res?.success ? res.data : [];
        })
    }

    bindService() {
        const id = this.invoiceForm.get('ddlVendor').value;
        this.invoiceForm.get('ddlVendorService').reset();
        this.vendorService.GetAllListByVendor({ id: id }).subscribe((res) => {
            if (res?.success && res.data) {
                this.serviceList = res.data;
            }
        })
    }

    onCountryChange(param: 'origin' | 'destination') {
        const isOrigin = param === 'origin';
        const countryCode = isOrigin
            ? this.invoiceForm.get('ddlOriginCountry').value
            : this.invoiceForm.get('ddlDestinationCountry').value;

        // Reset state and city fields based on whether it's origin or destination
        const stateControl = isOrigin ? 'ddlOriginState' : 'ddlDestinationState';
        const cityControl = isOrigin ? 'ddlOriginCity' : 'ddlDestinationCity';
        this.invoiceForm.controls[stateControl].reset();
        this.invoiceForm.controls[cityControl].reset();

        // Clear the corresponding city list
        if (isOrigin) {
            this.originCityList = [];
            this.bindStatesByCountry(countryCode, 'origin');
        } else {
            this.destinationCityList = [];
            this.bindStatesByCountry(countryCode);
        }

        // Optionally filter the allAWBList based on countryCode
        // this.allAWBList = this.allAWBList?.filter(x => (countryCode || (isOrigin ? x.origincountry : x.destinationcountry) === countryCode));
    }


    bindCountries() {
        try {
            this.geoService.GetAllCountries().subscribe((res) => {
                if (res && res.success) {
                    const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
                    const defaultCountryCode = metaInfo.defaultcountry;

                    if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
                        this.countryList = res.data;
                    } else if (metaInfo.operationtype.includes('Domestic')) {
                        this.countryList = res.data.filter(item => item.isocode === defaultCountryCode);
                        this.invoiceForm.get('ddlOriginCountry').setValue(defaultCountryCode);
                        this.invoiceForm.get('ddlOriginCountry').disable();
                        this.invoiceForm.get('ddlDestinationCountry').setValue(defaultCountryCode);
                        this.invoiceForm.get('ddlDestinationCountry').disable();
                        this.onCountryChange('origin');
                        this.onCountryChange('destination');
                    } else if (metaInfo.operationtype.includes('International')) {
                        this.countryList = res.data.filter(item => item.isocode !== defaultCountryCode);
                    } else {
                        this.countryList = res.data;
                    }
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindStatesByCountry(countryCode?: string, type?: any) {
        try {
            if (countryCode) {
                this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.countryCode = countryCode;
                        this[type === 'origin' ? 'originStateList' : 'destinationStateList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    onStateChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.invoiceForm.get('ddlOriginState').value;
            this.invoiceForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(countryCode, origin);
        }
        else {
            countryCode = this.invoiceForm.get('ddlDestinationState').value;
            this.invoiceForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(countryCode);
        }
    }

    bindCitiesByState(stateCode?: string, type?: any) {
        try {
            if (stateCode) {
                this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
                    if (res && res.success) {
                        this[type === 'origin' ? 'originCityList' : 'destinationCityList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    async openWarningDialog(msg: any) {
        Swal.fire({
            // title: 'Oops!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }

    async openConfirmationDialog(msg: any) {
        // Check if there is an API error
        const result = await Swal.fire({
            // title: 'Success!',
            html: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        if (result.isConfirmed) {
            this.router.navigate(['/invoices/sales']);
        }
    }

    formatter = (x: { name: string }) => x.name;

    search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.addressBookList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );

    bindAddressBook() {
        try {
            this.addressbookService.GetAll({ isactive: true, countryisocode: this.userData.metaInfo.defaultcountry }).subscribe((res) => {
                if (res && res.success) {
                    this.addressBookList = res.data;
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    // getAllPaymntModes() {
    //     this.miscService.GetAllPaymentModes().subscribe(res => {
    //       res && res.success ? this.paymentOptions = res.data : null;
    //     })
    //   }

    getConfigs() {
        this.configService.getAllGlobalConfig().subscribe((res) => {
            if (res && res.success) {
                // console.log("res?.data", res?.data);
                this.checkConfig(res?.data.filter(x => x.categoryname == 'AWB'));
            }
        })
    }

    checkConfig(awbconfig: any) {
        // console.log("awbconfig", awbconfig);
        for (let config in awbconfig) {
            switch (awbconfig[config].configurationcode) {
                case 'GENERATEINVALL':
                    this.awbConfig.isGenerateInVall = awbconfig[config].active;
                    break;
                default:
                    break;
            }
        }
    }
}
